import { useEffect } from 'react'
import { Navigation } from './components/Navigation'
import { Hero } from './sections/Hero'
import { WhyCodeNest } from './sections/WhyCodeNest'
import { InteractiveStory } from './sections/InteractiveStory'
import { Courses } from './sections/Courses'
import { Roadmaps } from './sections/Roadmaps'
import { Footer } from './sections/Footer'
import { useLenis } from './hooks/useLenis'

function App() {
  useLenis()

  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth'
    return () => {
      document.documentElement.style.scrollBehavior = 'auto'
    }
  }, [])

  return (
    <div className="relative min-h-screen bg-background text-white overflow-x-hidden">
      <Navigation />
      <main>
        <Hero />
        <WhyCodeNest />
        <InteractiveStory />
        <Courses />
        <Roadmaps />
      </main>
      <Footer />
    </div>
  )
}

export default App